import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';

class EthereumExplanation extends Component {
    render() {
        return (
            <div className="ethereum-explanation">
              <div className="basic-explanation">
                It costs 1 token to save a project, publicly. Projects saved publicly can be viewed by anyone.
              </div>

              <ConditionedComponent condition={this.props.advanced}>
                Think of them as stake in the platform, which is run as a cooperative. 
              </ConditionedComponent>
            </div>
        );
    }
}

export default EthereumExplanation;
